// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CFTa02N_jCU5u82zWoAX {
  flex: 1 0 auto;
}

.R6LrfmMRSeipqGnKGu1_ {
  top: calc(var(--header-height) + 1rem) !important;
  z-index: 110 !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;AACzB","sourcesContent":[".content {\n  flex: 1 0 auto;\n}\n\n.toastContainer {\n  top: calc(var(--header-height) + 1rem) !important;\n  z-index: 110 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `CFTa02N_jCU5u82zWoAX`,
	"toastContainer": `R6LrfmMRSeipqGnKGu1_`
};
export default ___CSS_LOADER_EXPORT___;
